import { LocalizedEnum } from '@mews/framework';
import { useTimeService } from '@mews-commander/ui';
import { RoutingRuleListTableRowData } from '../types';
import { getTimingDescription } from '../../../utils/timing';
import { RowTextCell } from './RowTextCell';

interface TimingCellProps {
    timing: RoutingRuleListTableRowData['timing'];
    processingStartOffset: RoutingRuleListTableRowData['processingStartOffset'];
}

export const TimingCell: React.FC<TimingCellProps> = ({ timing, processingStartOffset }) => {
    const timeService = useTimeService();
    return (
        <RowTextCell
            title={<LocalizedEnum value={timing} prefix="RoutingRuleTriggerType" />}
            description={getTimingDescription({
                triggerType: timing,
                processingStartOffset,
                timeService,
                withLegacyDescription: true,
            })}
        />
    );
};
